import Pdf from './Pdf'

export default Pdf
// eslint-disable-next-line import/export
export * from './Pdf'
